<template>
	<div>


		<div class="flex-x-center">
			<div class="profile-content">
				<div class="iconfont icon-tongguo flex-x-y-center pass-icon"></div>
				<div class="title flex-x-y-center">报考已完成</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	mapGetters,
	mapActions
} from "vuex";
import {
	erroralert,
	successalert
} from "@/utils/alert";
export default {
	data() {
		return {};
	},

	props: {
		// 流程
		process_index: 0,
		process: {
			type: Object,
			default() {
				return [];
			},
		},
	},
};
</script>

<style scoped>
.qualifications {
	color: rgb(219, 122, 65);
	letter-spacing: 1px;
	margin-top: 20px;
}

.unpassd-icono {
	font-size: 60px;
	color: #b8000d;
}

.advisement-icon {
	font-size: 60px;
	color: rgb(37, 110, 206);
}

.pass-icon {
	font-size: 60px;
	color: rgb(50, 187, 62);
}

.profile-content {
	margin-top: 20px;
	width: 83%;
	padding: 40px 50px 80px;
	background: white !important;
	border-radius: 5px;
	box-sizing: border-box;
}
</style>
